
























































































































import { Component, Watch, Vue } from 'vue-property-decorator';
import { locale, loadMessages } from 'devextreme/localization';
import nlMessages from 'devextreme/localization/messages/nl.json';
import SideNavigation from '@/components/navigation/sidenavigation.vue';
import SearchBox from '@/components/navigation/searchbox.vue';
import notificationService from './services/notificationService';
import cPopup from '@/components/default/Popup.vue';
import { DxLookup } from 'devextreme-vue';
import UserSettingDialog from '@/components/defaultPopups/defaultUserSettingsDialog.vue';
import AlertNavItem from '@/modules/userAlerts/components/AlertNavItem.vue';
import { LayoutConfig } from './installationConfig';

@Component({
  components: {
    SideNavigation,
    cPopup,
    DxLookup,
    SearchBox,
    UserSettingDialog,
    AlertNavItem,
  },
})
export default class App extends Vue {
  public locale: string = 'nl';
  public show: boolean = false;
  private showSidebar: boolean = true;
  private message = '';
  private userLoggedIn = false;
  private loadingFinished = false;
  public LayoutConfig = LayoutConfig;

  public async created() {
    const self = this;

    document.addEventListener('keydown', (zEvent) => {
      if (zEvent.altKey && zEvent.code === 'KeyW') {
        // case sensitive
        // DO YOUR STUFF HERE
        self.$store.commit('setZenmode', !self.zenmode);
        if (self.zenmode) {
          notificationService.zenmodeEnabled();
        } else {
          notificationService.zenmodeDisabled();
        }
      }
    });

    // setTimeout(() => {
    //   this.loadStores();
    // }, 150);

    this.loadLocale();
    this.loadHeadTitle();
  }

  private loadHeadTitle() {
    document.title = LayoutConfig.headTitle!;
  }

  private loadLocale() {
    let lang = localStorage.getItem('lang');
    if (!lang) {
      lang = 'nl';
    }
    this.locale = lang;
    localStorage.setItem('locale', this.locale);
    if (lang === 'nl') {
      loadMessages(nlMessages);
    }
    locale(lang);
    this.$i18n.locale = lang;
  }

  private refreshPage() {
    location.reload();
  }

  private clearCache() {
    localStorage.clear();
    sessionStorage.clear();
    setTimeout(() => {
      location.reload();
    }, 100);
  }

  private async loadStores() {
    if (this.loggedIn()) {
      const accessToken = await this.$auth.getAccessToken();
      const graphToken = await this.$auth.getAccessTokenForGraph();
      const axios = this.$axios;

      this.$store.dispatch('catalogs/fetch');
      this.$store.dispatch('articles/fetch');
      this.$store.dispatch('employees/fetch', { axios });
      this.$store.dispatch('settings/fetch');
      this.$store.dispatch('measuringUnits/fetch');

      // TODO: load user with fetch
      this.$store.dispatch('fetch');

      // TODO: Remove after article changes
      this.$store.dispatch('rawmaterials/fetch');
    } else {
      this.$auth.signIn();
    }
  }

  private showStatSettingsPopup() {
    const settingsDialog = this.$refs.usersettingsdialog as UserSettingDialog;
    settingsDialog.show = true;
    localStorage.setItem('usersettingsdialog', 'true');
  }

  private toggleNavbarTop() {
    this.showSidebar = !this.showSidebar;
  }

  private logout() {
    this.$auth.signOut();
  }

  private login() {
    this.$auth.signIn().then(() => {
      this.userLoggedIn = true;
    });
  }

  get zenmode() {
    return this.$store.getters.zenmode;
  }

  private mounted() {
    this.login();
    this.checkConnection();
  }

  private checkConnection() {
    const self = this;
    setInterval(() => {
      return (self.show = navigator.onLine ? false : true);
    }, 5000);
  }

  private reloadPage() {
    window.location.reload();
  }

  get currentUser() {
    return this.$store.getters.currentUser;
  }

  private loggedIn() {
    try {
      const user = this.$auth.getUser();
      return user ? true : false;
    } catch {
      this.$auth.signIn();
    }
  }

  get storeInitialised() {
    return this.$store.getters.initialised;
  }

  get rawmaterialsLoading() {
    return this.$store.getters['rawmaterials/loading'];
  }

  get articlesLoading() {
    return this.$store.getters['articles/loading'];
  }

  get catalogsLoading() {
    return this.$store.getters['catalogs/loading'];
  }

  get employeesLoading() {
    return this.$store.getters['employees/loading'];
  }

  get settingsLoading() {
    return this.$store.getters['settings/loading'];
  }

  get measuringUnitsLoading() {
    return this.$store.getters['measuringUnits/loading'];
  }

  get loadingMessage() {
    const numberOfSteps: number = 8;

    if (!this.loggedIn()) {
      return `1/${numberOfSteps}: Aanmelden...`;
    }

    if (!this.storeInitialised) {
      return `2/${numberOfSteps}: Ophalen basisgegevens`;
    }

    if (this.articlesLoading) {
      return `3/${numberOfSteps}: Codes laden`;
    }

    if (this.rawmaterialsLoading) {
      return `4/${numberOfSteps}: Grondstoffen laden`;
    }

    if (this.catalogsLoading) {
      return `5/${numberOfSteps}: Catalogus ophalen`;
    }

    if (this.employeesLoading) {
      return `6/${numberOfSteps}: Medewerkers laden`;
    }

    if (this.settingsLoading) {
      return `7/${numberOfSteps}: Instellingen laden`;
    }

    if (this.measuringUnitsLoading) {
      return `8/${numberOfSteps}: Meeteenheden laden`;
    }

    this.loadingFinished = true;
  }

  @Watch('userLoggedIn')
  private onLoggedInChanged() {
    this.loadStores();
  }
}
